import { makeStyles } from 'tss-react/mui';

const minHeightXs = '256px';
const minHeightSm = '380px';
const minHeightMd = '504px';
const minHeightLg = '504px';

const useStyles = makeStyles()(() => ({
  paperHeightXs: {
    minHeight: minHeightXs,
    maxHeight: 'min(calc(100vh - 48px), 564px)',
  },
  paperHeightSm: {
    minHeight: minHeightSm,
    maxHeight: 'min(calc(100vh - 48px), 804px)',
  },
  paperHeightMd: {
    minHeight: minHeightMd,
    maxHeight: 'min(calc(100vh - 48px), 804px)',
  },
  paperHeightLg: {
    minHeight: minHeightLg,
    maxHeight: 'min(calc(100vh - 48px), 804px)',
  },

  minHeightXs: {
    minHeight: minHeightXs,
  },
  minHeightSm: {
    minHeight: minHeightSm,
  },
  minHeightMd: {
    minHeight: minHeightMd,
  },
  minHeightLg: {
    minHeight: minHeightLg,
  },
}));

export default useStyles;
